import { CITY_NAME_TO_ID, NEIGHBORHOOD_NAME_TO_ID } from "../schema";

/**
 * Sends soft_signup update with current conversion state
 * Uses upsert endpoint - creates if doesn't exist, updates if it does
 * Fire-and-forget - doesn't block UI
 */
export const sendSoftSignupUpdate = (conversionState = {}) => {
  // Extract city_id and neighborhood_ids from conversionState
  const targetCity = conversionState?.targetCity;
  const neighborhoods = conversionState?.neighborhoods || [];
  
  let cityId = null;
  let neighborhoodIds = [];
  
  if (targetCity && CITY_NAME_TO_ID[targetCity]) {
    cityId = CITY_NAME_TO_ID[targetCity];
    
    // Map neighborhood names to IDs
    const neighborhoodMap = NEIGHBORHOOD_NAME_TO_ID[targetCity] || {};
    neighborhoodIds = neighborhoods
      .map((name) => neighborhoodMap[name])
      .filter((id) => id !== undefined);
  }
  
  const payload = { 
    conversionState,
    ...(cityId && { city_id: cityId }),
    ...(neighborhoodIds.length > 0 && { neighborhood_ids: neighborhoodIds })
  };
  
  // Use the upsert endpoint (creates if doesn't exist, updates if it does)
  fetch(`${process.env.REACT_APP_CORE_API_BASE_URL}/helpers/soft_signup/update`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "dealsAPIKey": process.env.REACT_APP_CORE_API_KEY,
    },
    body: JSON.stringify(payload)
  }).catch((error) => {
    console.error("soft_signup update failed", error);
  });
};

